<template>
    <ContentComp>
        <AlertMessage
            class="mb-5"
            type="info"
            title="station.timeshiftinfotitle"
            ><span v-html="$tm('station.timeshiftinfo', '', true)"></span
        ></AlertMessage>
        <FormLayout>
            <FormLayoutRow class="mt-5">
                <FormLayoutLabel text="station.timeshift"></FormLayoutLabel>
                <InputTimespan
                    v-model="value.Timeshift"
                    :format="'TIMEMS3'"
                />
            </FormLayoutRow>
            <!-- <FormLayoutRow>
                <FormLayoutLabel></FormLayoutLabel>
                <InputBool
                    label="station.timeshiftaffectprevious"
                    tooltip="station.timeshiftaffectprevioustooltip"
                    v-model="value.TimeshiftAllTimes"
                />
            </FormLayoutRow> -->
        </FormLayout>
    </ContentComp>
</template>
<script setup lang="ts">
import { AlertMessage, ContentComp, InputBool, InputTimespan } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import type { StationAlias } from '@/objects/generated';

/**
 * We need to send the entire station Alias because we can set two values one for the timeshift and also if it should affect previous registered times.
 */
const value = defineModel<StationAlias>({ required: true });
</script>
